import React from 'react';
import { Button, Modal } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

export function useArray(selectedRates) {
    if (selectedRates instanceof Array) {
        return selectedRates;
    }
    if (!selectedRates) {
        return [];
    }
    return [selectedRates];
}

export function DeleteModal({ objectsToDelete = null, show = false, onSubmit = () => {}, onClose = () => {}, labelButton = null, labelTitle = null, labelBody = null }) {
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState(false);

    labelButton = labelButton || t('ticket.common.action.delete');
    labelTitle = labelTitle || t('ticket.modal.deleteTitle');
    labelBody = labelBody || t('ticket.modal.irreversible');

    const _objects = React.useMemo(() => useArray(objectsToDelete), [objectsToDelete]);

    const handleSubmit = React.useCallback(() => {
        setLoading(true);
        onSubmit(() => setLoading(false));
    }, [onSubmit]);

    if (_objects.length === 0) {
        return null;
    }

    return (
        <Modal
            open={Boolean(_objects.length) && show}
            onClose={onClose}
            title={labelTitle}
            submitButton={<Button primary isLoading={loading} onClick={handleSubmit} label={labelButton} />}
            cancelButton={<Button disabled={loading} onClick={onClose} label={t('ticket.common.action.cancel')} />}
        >
            {labelBody}
        </Modal>
    );
}

DeleteModal.propTypes = {
    objectsToDelete: PropTypes.array,
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
    show: PropTypes.bool,
    labelButton: PropTypes.string,
    labelTitle: PropTypes.string,
    labelBody: PropTypes.string
};
